export const config_rows_v105 = [
  { name: "hand_control_title", type: "header", edit_pages: "collection" },
  { name: "mode", type: "item" },
  { name: "interface_type", type: "item" },
  { name: "electrode_select", type: "item" },

  { name: "input_settings_title", type: "header", edit_pages: "input_graph" },
  { name: "elec_a_on_threshold", type: "item" },
  { name: "elec_a_cocon_threshold", type: "item" },
  { name: "elec_a_max_threshold", type: "item" },
  { name: "elec_a_maximum_input", type: "item" },
  { name: "elec_a_maximum_speed", type: "item" },
  { name: "", type: "empty" },
  { name: "elec_b_on_threshold", type: "item" },
  { name: "elec_b_cocon_threshold", type: "item" },
  { name: "elec_b_max_threshold", type: "item" },
  { name: "elec_b_maximum_input", type: "item" },
  { name: "elec_b_maximum_speed", type: "item" },

  { name: "grip_switch_triggers_title", type: "header", edit_pages: "grip_switch_triggers" },
  { name: "single_open", type: "item" },
  { name: "hold_open", type: "item" },
  { name: "single_co_contraction", type: "item" },
  { name: "thumb_tap_pronate_non_opposed", type: "item" },
  { name: "thumb_tap_pronate_opposed", type: "item" },
  { name: "thumb_tap_supinate_non_opposed", type: "item" },
  { name: "thumb_tap_supinate_opposed", type: "item" },
  { name: "thumb_tap_pronate", type: "item" },
  { name: "thumb_tap_supinate", type: "item" },
  { name: "thumb_tip_hold", type: "item" },
  { name: "index_hold", type: "item" },
  { name: "four_finger_hold", type: "item" },
  { name: "back_button_hold", type: "item" },
  { name: "map_to_grip", type: "item" },
  { name: "map_to_grip2", type: "item" },
  { name: "map_to_grip3", type: "item" },
  { name: "map_to_grip4", type: "item" },

  { name: "additional_setup_title", type: "header", edit_pages: "common_options" },
  { name: "buzzer", type: "item" },
  { name: "vibration", type: "item" },
  { name: "auto_grip", type: "item" },
  { name: "thumb_mode", type: "item" },
  { name: "auto_relax", type: "item" },
  { name: "display_options", type: "item" },
  { name: "default_switch_time", type: "item" },
  { name: "grip_strength", type: "item" },
  { name: "thumb_strength", type: "item" },
  { name: "digit_hold_time", type: "item" },
  { name: "grip_switch_time_dual_site_open_close", type: "item" },
  { name: "hold_open_time_dual_site_open_close", type: "item" },
  { name: "short_burst_time", type: "item", mode: "00" },
  { name: "direction_change_time", type: "item", mode: "01" },
  { name: "elec_a_cocon_time", type: "item", mode: "02" },

  { name: "grip_tables_title", type: "header", edit_pages: "grip_tables" },
  { name: "table_a_grip_1", type: "item" },
  { name: "table_a_grip_2", type: "item" },
  { name: "table_a_grip_3", type: "item" },
  { name: "table_a_grip_4", type: "item" },
  { name: "table_a_grip_5", type: "item" },
  { name: "table_a_grip_6", type: "item" },
  { name: "", type: "empty" },
  { name: "table_b_grip_1", type: "item" },
  { name: "table_b_grip_2", type: "item" },
  { name: "table_b_grip_3", type: "item" },
  { name: "table_b_grip_4", type: "item" },
  { name: "table_b_grip_5", type: "item" },
  { name: "table_b_grip_6", type: "item" },
  { name: "", type: "empty" },
  { name: "table_c_grip_1", type: "item" },
  { name: "table_c_grip_2", type: "item" },
  { name: "table_c_grip_3", type: "item" },
  { name: "table_c_grip_4", type: "item" },
  { name: "table_c_grip_5", type: "item" },
  { name: "table_c_grip_6", type: "item" },
  { name: "", type: "empty" },
  { name: "table_d_grip_1", type: "item" },
  { name: "table_d_grip_2", type: "item" },
  { name: "table_d_grip_3", type: "item" },
  { name: "table_d_grip_4", type: "item" },
  { name: "table_d_grip_5", type: "item" },
  { name: "table_d_grip_6", type: "item" },
]
